import jQuery from 'jquery';

(function (factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD (Register as an anonymous module)
    define(['jquery'], factory);
  } else if (typeof exports === 'object') {
    // Node/CommonJS
    module.exports = factory(require('jquery'));
  } else {
    // Browser globals
    factory(jQuery);
  }
}(function ($) {

  // Create the listener function that will be used to disconnect the
  // transition event and restore the auto height property
  var revertToAuto = function revertToAuto(event) {

    // Get the element that has finished animating
    var $target = $(this);

    // Disconnect the transitionend listener
    $target.off('transitionend', revertToAuto);

    // Clear the special css rules set by the plugin to restore the original
    // behavior of the element

    // Store the current animation property so that it can be disabled while
    // setting the pre-modification height. This helps browsers like Safari and
    // iOS that potentially interpret auto height as a 0 height
    var storedTransition = $target.css('transition');

    // To handle the broken auto height in Safari and iOS. The transition
    // property has to be removed when setting the height back to auto,
    // otherwise the page will jump up and down
    $target.css({height: '', transition: 'none'});

    // Update the transition property back to what it was asynchronously so that
    // the browser is given a chance to render the auto height change
    setTimeout(function() {
      $target.css({transition: storedTransition});

      // Trigger an event when the animation has completed
      $target.trigger('endautoheightanimate');
    }, 0);
  };

  // Create the new append / html function that handles transitioning the
  // element from an auto height element to a fixed height element
  var animateAppendHTML = function animateAppendHTML($element, method, data) {

    // Get the pre-modification element height
    var preHeight = $element.outerHeight();

    // Store the current animation property so that it can be disabled while
    // setting the pre-modification height. This helps browsers like Safari and
    // iOS that potentially interpret auto height as a 0 height
    var storedTransition = $element.css('transition');

    // Call the jQuery append or html method to update the element
    $.fn[method].call($element, data);

    // Get the new post-modification element height
    var postHeight = $element.
      css({height: 'auto', transition: 'none'}).
      outerHeight();

    // Update the element so that it is a fixed height element and is set with
    // the pre-modification height
    $element.css({height: preHeight});

    // Attach a listener to the transitionend event to return this element to
    // auto height when the transition has finished
    $element.on('transitionend', revertToAuto);

    // Create a delayed execution that will update the element to the post
    // modification height so that there is a chance to render the $element
    // with the pre modification height
    setTimeout(function() {

      // Trigger an event when the animation starts
      $element.trigger('startautoheightanimate');

      $element.css({height: postHeight, transition: storedTransition});
    }, 0);
  };

  $.fn.animateHTML = function(data) {

    animateAppendHTML($(this), 'html', data);

    // Return the called context
    return this;
  };

  $.fn.animateAppend = function(data) {

    animateAppendHTML($(this), 'append', data);

    // Return the called context
    return this;
  };
}));

export default {}